import React, { ReactElement } from 'react';
import { Translate } from 'react-redux-i18n';
import EmergencyInformationForm from './EmergencyInformationForm';
import { UserDTO } from '../../../../../network/api/types/compte/UserDTO';

type Props = {
  onClose: () => void
  userDetails: UserDTO
  fetchEmergencyInfos : () => void
  setDirty?: (dirty: boolean, callback?: () => void) => void
  setModalI18n?: (title: string, subtitle: string) => void
};

function EmergencyInformation(props: Props): ReactElement {
  return (
    <div>
      <div className="centered-form">
        <div className="drawer-title">
          <h3>
            <Translate value="EMERGENCY_INFORMATION.EMERGENCY_INFORMATION" />
          </h3>
          <div className="subtitle">
            <Translate value="HOME.RECOVER_ACCOUNT" />
          </div>
        </div>
        <EmergencyInformationForm
          onClose={props.onClose}
          userDetails={props.userDetails}
          fetchEmergencyInfos={props.fetchEmergencyInfos}
          setDirty={props.setDirty}
          setModalI18n={props.setModalI18n}
        />
      </div>
    </div>
  );
}

export default EmergencyInformation;
